import type { ReactNode } from "react";

interface PageProps {
  readonly children: ReactNode;
  readonly foot?: ReactNode;
  /** Centre the content in the space above the tab bar, for a page with little on it. */
  readonly middle?: boolean;
}

/**
 * A tab's or detail page's body. On a phone the foot is pinned above the
 * tab bar; on a desktop, where the shell already gives the content a
 * reading column, the foot follows the content at the column's width.
 */
export function Page({ children, foot, middle = false }: PageProps) {
  const layout = middle ? "flex flex-col justify-center-safe" : "";
  return (
    <div className="flex flex-1 flex-col">
      <div className={`flex-1 px-gutter pb-6 pt-5 md:px-0 md:pt-2 ${layout}`}>{children}</div>
      {foot && (
        <div className="sticky bottom-app flex flex-col gap-2 bg-paper px-gutter pb-4 pt-3 md:static md:mt-6 md:max-w-[440px] md:px-0">
          {foot}
        </div>
      )}
    </div>
  );
}
